/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Try_Magic_Placeholder_5Inputs */

const en_try_magic_placeholder_5 = /** @type {(inputs: Try_Magic_Placeholder_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Let your words flow...`)
};

const es_try_magic_placeholder_5 = /** @type {(inputs: Try_Magic_Placeholder_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deja fluir tus palabras...`)
};

/**
* | output |
* | --- |
* | "Let your words flow..." |
*
* @param {Try_Magic_Placeholder_5Inputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const try_magic_placeholder_5 = /** @type {((inputs?: Try_Magic_Placeholder_5Inputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Try_Magic_Placeholder_5Inputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_try_magic_placeholder_5(inputs)
	return en_try_magic_placeholder_5(inputs)
});